"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#1F1F1F' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 1 : _d;
    return (react_1.default.createElement("svg", { viewBox: "0 0 24 24", width: scale * 24, height: scale * 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M19.82 2H4.18A2.18 2.18 0 0 0 2 4.18v15.64A2.18 2.18 0 0 0 4.18 22h15.64A2.18 2.18 0 0 0 22 19.82V4.18A2.18 2.18 0 0 0 19.82 2zM7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5", stroke: color, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Icon;
//# sourceMappingURL=FilmSlide.js.map